import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";
import { ROLE_LABELS } from "@/lib/constants";

export default function Navbar({ links = [] }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-border/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center gap-6">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-9 h-9 rounded-md bg-primary text-primary-foreground grid place-items-center font-display font-bold text-sm">
            NF
          </div>
          <div className="hidden sm:block">
            <div className="font-display font-semibold tracking-tight leading-none">Noise Free Nagpur</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1 ml-4">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.key}`}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-slate-100 hover:text-slate-900 ${
                loc.pathname === l.to ? "bg-slate-100 text-slate-900" : "text-slate-600"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-md bg-slate-100 text-slate-800">
                <User className="w-4 h-4" />
                <div className="text-sm leading-none">
                  <div className="font-medium">{user.name}</div>
                  <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-0.5">
                    {ROLE_LABELS[user.role] || user.role}
                    {user.zone ? ` · ${user.zone}` : ""}
                  </div>
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={handleLogout}
                data-testid="logout-btn"
                className="gap-2"
              >
                <LogOut className="w-4 h-4" /> Logout
              </Button>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/login">
                <Button variant="outline" size="sm" data-testid="nav-login-btn">
                  Login
                </Button>
              </Link>
              <Link to="/register">
                <Button size="sm" data-testid="nav-register-btn">
                  Register
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
